module.exports = __webpack_public_path__ + "static/img/xx.0f292df.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/xx.png
// module id = fG6B
// module chunks = 1